import { jsx as _jsx } from "react/jsx-runtime";
import { RICH_TEXT_ALLOWED_ATTRIBUTES, RICH_TEXT_ALLOWED_SCHEMES, RICH_TEXT_ALLOWED_TAGS, } from '@ibe/constants';
import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import { cn } from '../lib/cn.js';
/** The attribute allowlist, flattened the way DOMPurify wants it. */
const ALLOWED_ATTR = [...new Set(Object.values(RICH_TEXT_ALLOWED_ATTRIBUTES).flat())];
const ALLOWED_URI_REGEXP = new RegExp(`^(?:${RICH_TEXT_ALLOWED_SCHEMES.join('|')}):`, 'iu');
export function RichTextView({ html, emptyMessage, className, }) {
    // Memoised on the document: sanitising is a full parse, and a detail screen
    // re-renders on every unrelated state change around it.
    const clean = useMemo(() => html === null || html === undefined || html === ''
        ? ''
        : DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [...RICH_TEXT_ALLOWED_TAGS],
            ALLOWED_ATTR,
            ALLOWED_URI_REGEXP,
            // Keeps the text of a disallowed tag rather than the tag, matching
            // `disallowedTagsMode: 'discard'` on the server. The two layers
            // answering differently would make the preview a lie.
            KEEP_CONTENT: true,
        }), [html]);
    if (clean === '') {
        return emptyMessage === undefined ? null : (_jsx("p", { className: "text-caption text-muted-foreground", children: emptyMessage }));
    }
    return (_jsx("div", { className: cn('space-y-3 text-body [&_a]:underline [&_h2]:text-h2 [&_h2]:font-semibold', '[&_h3]:text-h3 [&_h3]:font-semibold [&_h4]:font-semibold', '[&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6', '[&_table]:w-full [&_td]:border [&_td]:border-border [&_td]:p-2', '[&_th]:border [&_th]:border-border [&_th]:p-2 [&_th]:text-left', className), 
        // The one place in the portal this is acceptable, and only because the
        // value it is handed came out of DOMPurify three lines above.
        dangerouslySetInnerHTML: { __html: clean } }));
}
//# sourceMappingURL=rich-text-view.js.map